import { SpacerElement } from '@typedream/components';
import { DreamBlock } from '@typedream/core';
import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_SPACER } from '../../pluginKeys';
import { withDropTarget } from '../../plugins/dnd';

export const createSpacerPlugin = createTElementPluginFactory({
  key: ELEMENT_SPACER,
  component: withDropTarget(SpacerElement),
  isVoid: true,
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: {
      dimensionIndicator: true,
    },
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/canvas/images/spacer.png',
      title: 'Spacer',
      subtitle: 'A box that can be resized vertically and horizontally for spacing',
      keywords: ['spacer', 'space', 'vertical', 'height', 'width'],
    },
    format: {
      formatType: 'block',
      blurAfterSet: true,
      insertNode: {
        type: ELEMENT_SPACER,
        height: 50,
        children: [
          {
            text: '',
          },
        ],
      } as DreamBlock,
      turnInto: [],
      focusableWhenEmpty: false,
      validProperties: ['height', 'width', 'mobile_hide', 'desktop_hide', 'margin'],
      validChildrenTypes: [],
    },
  },
});
